export default "__VITE_ASSET__Ch8jernb__"